import { LinkField } from "./linkField"

export const FooterCTA = ({ ctaHeading, ctaLink }) => {
  return (
    <div className="xl:mt-44 masked-image--flipped">
      <div className="w-full bg-primary py-36">
      {/* <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 1420 320">
        <path
          fill="#0070f0"
          fillOpacity="1"
          d="M0,320L1440,224L1440,320L0,320Z"
        />
      </svg>         */}
      <h1 className="text-3xl font-semibold leading-10 text-center text-white lg:text-4xl ">
          {ctaHeading}
        </h1>
        <div className="flex justify-center pt-16 mx-auto ">
          <LinkField {...ctaLink}>
            <button
              type="button"
              className="px-6 py-2 text-white bg-transparent border-2 border-white hover:bg-pink hover:border-pink lg:px-12 lg:py-3 rounded-xl"
            >
              {ctaLink.text}
            </button>
          </LinkField>
        </div>
      </div>
    </div>
  )
}
